import { FormDrawer, FormDrawerContent, Id, RoleOptionResource, isSuccess, roleService, useToasts } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createUserRolesService } from "../shared/api/userService";
import { UserRoleMultiSelect } from "../shared/select/UserRoleSelect";

interface Props {
	userId: Id;
	open: boolean;
	handleClose: () => void;
}

interface FormState {
	roles: RoleOptionResource[];
}
export const UserRolesAttachDrawer: FC<Props> = ({ open, handleClose, userId }) => {
	const { t } = useTranslation();
	const { showToast } = useToasts();
	const queryClient = useQueryClient();
	const service = useMemo(() => createUserRolesService(userId), [userId]);

	const onSubmit = useCallback(
		async ({ roles }: FormState) => {
			const res = await service.attachRoles(roles.map((x) => x.id));

			if (isSuccess(res)) {
				showToast({
					title: t("Roles"),
					body: t("Successfully attached to the user"),
					type: "success",
				});
				void queryClient.invalidateQueries({ queryKey: service.listKey });
				void queryClient.invalidateQueries({ queryKey: service.roleOptionsByUserKey });
				void queryClient.resetQueries({ queryKey: roleService.indexKey });
				handleClose();
				return true;
			}
			return false;
		},
		[handleClose, queryClient, service, showToast, t],
	);

	return (
		<FormDrawer
			open={open}
			onClose={handleClose}
			initialValues={{ roles: [] }}
			title={t("Attach roles")}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<UserRoleMultiSelect name="roles" label={t("Roles")} required={true} userId={userId} />
				</FormDrawerContent>
			)}
			onSubmit={onSubmit}
		/>
	);
};
